 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0,
 		0: 0,
 		1: 0,
 		2: 0,
 		3: 0,
 		4: 0,
 		10: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~ContentAccessLookup~MergeApproval~MergeRequest~OneRosterOrgs~ProvisionSchools~Pygmalion","6":"MergeApproval~MergeRequest~UserDash","7":"News","8":"Bulk-Processing-Status","9":"MergeApproval~MergeRequest","11":"AssignmentContainer","12":"AssignmentsContainer","13":"BulkRoster","14":"ContentAccessLookup","15":"District-Report","16":"Home","17":"LazyAssignedArticleReviewContainer","18":"LazyCanvasAssignmentReviewContainer","19":"LazySearchComponent","20":"LessonSparkContainer","21":"MergeApproval","22":"MergeRequest","23":"OneRosterOrgs","24":"OpenMergeRequests","25":"ProvisionSchools","26":"Pygmalion","27":"ReadContainer","28":"StandaloneExternalEmbed","29":"StandalonePoll","30":"StandardContainer","31":"TeacherBinder","32":"TextSets","33":"UnitsContainer","34":"UserDash","35":"YourContentContainer","37":"browse","40":"vendors~ProvisionSchools","41":"vendors~browse"}[chunkId]||chunkId) + "." + {"0":"e77a6dd1fb327e98dd40","1":"8368965eb47f8105cfa0","2":"a2ac7fb62790d050dc72","3":"19baa75d43a22044715f","4":"5de5917b18f9e65415af","5":"c3056475e65bae111cd7","6":"23f832f53b85737c010b","7":"fcf9954c5c0b8ed1e226","8":"7aee9167830f8b57146b","9":"929467f2d4d10b2c3b87","10":"f7dfc871ea34bf10752c","11":"5de117e2e82b4eabb657","12":"4f140edc1e08fc015372","13":"e086e5ef02d0e00cce7c","14":"03fdc0d85619b570a009","15":"8f1e2ffa96a04ae204fe","16":"b2b7b68a329d6bd94e4c","17":"20ba3ee9de3a2ad0e221","18":"aae974f019e6b608733d","19":"09d864fb6f54a5ec4421","20":"bea420227290955052e7","21":"169a7456f890297a8301","22":"2d9b002484b587cf9ccf","23":"d10021e6850d794532a0","24":"446b53eb1a244a953c4b","25":"e0ce994dae19ca743306","26":"e518a11909e7ad28e999","27":"14c926ed617d2ee3af4b","28":"27c308a181d89fbc2f5b","29":"9e8b0a45d645164ac1c6","30":"4452db9bfcb506765fb3","31":"ad79621bd3beef71d8ce","32":"d7cb0534c7a3be685427","33":"b49c22f3f8a0705afa88","34":"1e2a9a9b92e81d50b061","35":"daa07a66c0c801607faf","37":"6b8f18e078460c30a03b","40":"f177f42875da595ad31a","41":"b1d3ce2565ba60d284e6","42":"2c4cbc94362474ccf198","43":"1cc1c35812dfd69b8a35","44":"b6e1e87b98ad891dcb17","45":"fd4d9a9a1ff8833cba2f","46":"e0ccacfca9b7d174d90c","47":"7767f5e7165d2cf957a2","48":"e464e500dacef9d74adc","49":"a251673177886336fd0f","50":"e6da5a9a0bcc6b5d67ee","51":"7106525e914a5c7fe361","52":"695b6551a6eec1e11c44"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1609);
